import React from "react";
import { Space, Typography } from "antd";
import { ClockCircleOutlined, CoffeeOutlined, InfoCircleOutlined, UserOutlined } from "@ant-design/icons";
import moment from "moment-timezone";
import dayjs from "dayjs";

import { cropStaffName } from "utils/helper";

const { Text } = Typography;

const SelectedServiceInfoCard = ({ selectedService }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <Text strong style={{ fontSize: 16, color: "#262626" }}>
            {selectedService.equipment?.[0]?.name || "Embarcação N/A"}
          </Text>
          <Text style={{ fontSize: 16, color: "#595959", marginLeft: 8 }}>• {selectedService.product?.name || "N/A"}</Text>
        </div>
        {selectedService?.entries?.[0]?.internal_notes && (
          <Space size={4} align="start">
            <InfoCircleOutlined style={{ color: "#faad14", marginTop: 4 }} />
            <Text style={{ color: "#595959" }}>
              <strong>Notas Especiais:</strong> {selectedService?.entries[0].internal_notes}
            </Text>
          </Space>
        )}
        <Space size={16} wrap>
          <Space size={4}>
            <UserOutlined style={{ color: "#8c8c8c" }} />
            <Text style={{ color: "#595959" }}>{selectedService.staff?.map((s) => cropStaffName(s.name)).join(", ") || "N/A"}</Text>
          </Space>
          <Space size={4}>
            <ClockCircleOutlined style={{ color: "#8c8c8c" }} />
            <Text style={{ color: "#595959" }}>
              {moment(selectedService.final_start_date).format("HH:mm")} - {moment(selectedService.final_end_date).format("HH:mm")}
            </Text>
          </Space>
        </Space>
        <Space size={4}>
          {selectedService?.entries.map((entry) => {
            if (entry.product.product_for_service !== null) {
              return (
                <Text style={{ color: "#ff4d4f", fontWeight: 700 }}>
                  Desagua: {entry.product.name} | {entry.passenger?.name ? entry.passenger.name : entry.entity?.name} | PAX:
                  {entry.passengersList?.map((p) => p.pax_i + p.pax_m + p.pax_z)}
                </Text>
              );
            } else {
              return null;
            }
          })}
        </Space>
        {selectedService.catering && (
          <Space size={4}>
            <CoffeeOutlined style={{ color: "#8c8c8c" }} />
            <Text style={{ color: "#595959" }}>Catering: {selectedService.catering ? "Sim" : "Não"}</Text>
          </Space>
        )}
      </div>
      <div style={{ display: "flex", flexDirection: "column", marginRight: 20 }}>
        {selectedService?.embarked_count && (
          <Text style={{ fontSize: 15 }}>
            <strong>Total de Pessoas a Bordo:</strong> {selectedService.embarked_count}
          </Text>
        )}
        {selectedService?.start_date_effective && (
          <Text style={{ fontSize: 15 }}>
            <strong>Data de Início Real:</strong> {dayjs(selectedService.start_date_effective).format("HH:mm")}
          </Text>
        )}
        {selectedService?.end_date_effective && (
          <Text style={{ fontSize: 15 }}>
            <strong>Data de Fim Real:</strong> {dayjs(selectedService.end_date_effective).format("HH:mm")}
          </Text>
        )}
      </div>
    </div>
  );
};

export default SelectedServiceInfoCard;
